import { ContainerModule } from '@patsnap/tahiti-core/shared/inversify';
import { ToolsService } from '@/services/tools-service/tools-service';
import { ToolsServiceImpl } from '@/services/tools-service/impls/tools-service';
import { permissionModule } from '@/domains/permission';
import { CurrentTaskService } from '@/services/current-task/current-task-service';
import { CurrentTaskServiceImpl } from '@/services/current-task/impls/current-task-service';
import { taskModule } from '@/domains/task';
import { TimeZoneService, TimeZoneUpdater } from '@/services/date-format/time-zone-service';
import { TaskDateFormatter } from '@/services/date-format/task-date-formatter';
import { TaskDateFormatterImpl } from '@/services/date-format/impls/task-date-formatter';
import { creditModule } from '@/domains/credit';
import { TimeZoneServiceImpl } from '@/services/date-format/impls/time-zone-service';
import { embodimentGeneratorModule } from '@/presentation/pages/specification/components/embodiment-generator';
import { referencePatentsModule } from '@/domains/reference-patents';
import { ClientService } from '@telecom/shared/services/client/client-service';
import { ClientServiceImpl } from '@telecom/shared/services/client/imps/client-service';
import { linkModule } from '@telecom/shared/services/link-service';
import { noveltyCheckReportModule } from '@/domains/novelty-check-report';
import { ftoReportModule } from '@/domains/fto-report';
import { SharePageService } from '@/services/share-page/share-page-service';
import { SharePageServiceImpl } from '@/services/share-page/impls/share-page-service-impls';
import { SharePageInterceptorService } from '@/services/share-page/share-page-interceptor-service';
import { SharePageInterceptorServiceImpl } from '@/services/share-page/impls/share-page-interceptor-service-impls';
import { PatentProfileService } from '@/services/patent-service/patent-profile-service';
import { PatentProfileServiceImpl } from '@/services/patent-service/impls/patent-profile-service-impl';
import { embodimentImprovementModule } from '@/presentation/pages/specification/components/embodiment-improvement';
import { ftoProModule } from '@/domains/fto-pro';
import { proofReadingModule } from '@/domains/proof-reading';
import { hubspotModule } from './hubspot-module';
import { pricingModule } from './pricing-module';
import { fileUploadModule } from './file-upload-module';
import { ShareLinkServiceImpl } from '@/services/share-page/impls/share-link-service-impl';
import { ShareLinkService } from '@/services/share-page/share-link-service';
import { oarModule } from '@/domains/oar';
import { designFtoModule } from '@/presentation/pages/design-fto';
import { saveToWorkspaceModule } from '@/features/save-to-workspace';
import { usageLimitModalModule } from '@/features/usage-limit-modal';
import { onboardingCommonModule } from '@/features/onboarding/common';
import { noveltySearchOnboardingModule } from '@/features/onboarding/novelty-search';
import { ftoProOnboardingModule } from '@/features/onboarding/fto-pro';
import { designFtoOnboardingModule } from '@/features/onboarding/design-fto';
import { workInProgressModule } from '@/features/work-in-progress';

export const businessModule = new ContainerModule((bind) => {
    bind(ToolsService).to(ToolsServiceImpl);
    bind(SharePageService).to(SharePageServiceImpl);
    bind(ShareLinkService).to(ShareLinkServiceImpl);
    bind(SharePageInterceptorService).to(SharePageInterceptorServiceImpl);
    bind(CurrentTaskService).to(CurrentTaskServiceImpl);
    bind(TaskDateFormatter).to(TaskDateFormatterImpl);
    bind(TimeZoneServiceImpl).toSelf();
    bind(TimeZoneUpdater).toService(TimeZoneServiceImpl);
    bind(TimeZoneService).toService(TimeZoneServiceImpl);
    bind(ClientService).to(ClientServiceImpl);
    bind(PatentProfileService).to(PatentProfileServiceImpl);

    // 加载 HubSpot 模块
    hubspotModule(bind);

    // 加载 Pricing 模块
    pricingModule(bind);

    // 加载用量限制弹窗模块
    usageLimitModalModule(bind);

    // 加载首次引导公共依赖及各 Agent 首页首次引导模块
    onboardingCommonModule(bind);
    noveltySearchOnboardingModule(bind);
    ftoProOnboardingModule(bind);
    designFtoOnboardingModule(bind);
    workInProgressModule(bind);

    // 加载文件上传模块
    fileUploadModule(bind);

    permissionModule(bind);
    creditModule(bind);
    taskModule(bind);
    embodimentGeneratorModule(bind);
    referencePatentsModule(bind);
    linkModule(bind);
    noveltyCheckReportModule(bind);
    ftoReportModule(bind);
    embodimentImprovementModule(bind);
    ftoProModule(bind);
    proofReadingModule(bind);
    oarModule(bind);
    designFtoModule(bind);
    saveToWorkspaceModule(bind);
});
